export default __webpack_public_path__ + "static/media/logo.cc93306f.svg";